import { render, staticRenderFns } from "./JudgeListDefaultLayout.vue?vue&type=template&id=2167d532&scoped=true&"
import script from "./JudgeListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./JudgeListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2167d532",
  null
  
)

export default component.exports